import { render, staticRenderFns } from "./ProductsListAsideDocs.vue?vue&type=template&id=ca3a9222&scoped=true"
import script from "./ProductsListAsideDocs.vue?vue&type=script&lang=js"
export * from "./ProductsListAsideDocs.vue?vue&type=script&lang=js"
import style0 from "./ProductsListAsideDocs.vue?vue&type=style&index=0&id=ca3a9222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3a9222",
  null
  
)

export default component.exports